import { useEffect } from 'react';
import KrillChat from 'krill';
import localData from 'utils/localData';
import AuthProvider from './AuthProvider';
import { LANGUAGE, USER_DATA } from 'shared/constants/users';
import AppUpdateProvider from './AppUpdateProvider';
import UpdateModal from 'components/UpdateAvailableModal/UpdateAvailableModal';

const App = () => {
  useEffect(() => {
    const krillInit = async () => {
      try {
        await KrillChat.Config.init({
          DEFAULT_LANGUAGE: LANGUAGE.ENGLISH,
          CURRENT_LANGUAGE: localData.get(USER_DATA.PREFFERED_LANGUAGE),
          BROWSWER_STORAGE:
            import.meta.env.VITE_BROWSER_STORAGE === `localStorage`
              ? window.localStorage
              : window.sessionStorage,
          AXIOS_URL: import.meta.env.VITE_KRILL_CHAT_AXIOS_URL,
          AXIOS_TIMEOUT: 60000,
          ADMIN_URL: import.meta.env.VITE_KRILL_CHAT_ADMIN_URL,
          IM_URL: import.meta.env.VITE_KRILL_CHAT_IM_URL,
        });
      } catch (err) {
        console.log(err);
      }
    };

    krillInit();
  }, []);

  return (
    <AppUpdateProvider>
      <AuthProvider />
      <UpdateModal />
    </AppUpdateProvider>
  );
};

export default App;
